import _ from 'lodash';
import bffcli from '../bffcli';

const errorHandler = err => {
  console.log(err);
};

export const fetchSavedCoupons = async () => {
  try {
    const saveCoupon = await bffcli.get('/coupon/fetchCoupons');
    if (!_.isEmpty(saveCoupon.data)) {
      return saveCoupon.data;
    }
  } catch (err) {
    errorHandler(err);
    return false;
  }
};

export const fetchDrugStructure = async (seoName, locale) => {
  try {
    const drugStructure = await bffcli.post('/coupon/fetchstructure', {
      seoName,
      locale
    });
    if (!_.isEmpty(drugStructure.data)) {
      return drugStructure.data;
    }
  } catch (err) {
    errorHandler(err);
    return false;
  }
};

export const saveCoupon = async couponData => {
  try {
    const saveCoupon = await bffcli.post('/coupon/saveCoupon', {
      couponData
    });
    if (!_.isEmpty(saveCoupon.data)) {
      return saveCoupon.data;
    }
  } catch (err) {
    errorHandler(err);
    return false;
  }
};

export const editCoupon = async (
  drugId,
  ndc,
  quantity,
  couponId,
  isCustomQuantity
) => {
  try {
    const editCouponResponse = await bffcli.post('/coupon/editCoupon', {
      drugId,
      ndc,
      quantity,
      couponId,
      isCustomQuantity
    });
    if (!_.isEmpty(editCouponResponse.data)) {
      return editCouponResponse.data;
    }
  } catch (err) {
    errorHandler(err);
    return false;
  }
};

// working fine
export const deleteDrugCoupon = async (ndc, quantity) => {
  try {
    const deleteDrugCoupon = await bffcli.post('/coupon/deleteDrugCoupon', {
      ndc,
      quantity
    });
    if (!_.isEmpty(deleteDrugCoupon.data)) {
      return deleteDrugCoupon.data;
    }
  } catch (err) {
    errorHandler(err);
    return false;
  }
};

export const deleteAllCoupons = async couponId => {
  try {
    const deleteAllCouponResponse = await bffcli.post(
      '/coupon/deleteAllCoupons',
      {
        couponId
      }
    );
    if (!_.isEmpty(deleteAllCouponResponse.data)) {
      return deleteAllCouponResponse.data;
    }
  } catch (err) {
    errorHandler(err);
    return false;
  }
};

export const deletePharmacyCoupon = async (pharmacyData, couponId) => {
  try {
    const deletePharmacyCouponResponse = await bffcli.post(
      '/coupon/deletePharmacyCoupon',
      {
        pharmacyData,
        couponId
      }
    );
    if (!_.isEmpty(deletePharmacyCouponResponse.data)) {
      return deletePharmacyCouponResponse.data;
    }
  } catch (err) {
    errorHandler(err);
    return false;
  }
};
